import { memo } from "react";
import IconABTACertification from "./IconABTACertification";
import "./CondensedBookWithConfidence.scss";
import { FooterAtolIcon } from "app/icons/logo";

const CondensedBookWithConfidence = () => {
	return (
		<div className="book-with-confidence-booking-page">
			<div className="book-with-confidence-booking-page__text-container">
				<p>Book with confidence</p>
				<p>ATOL & ABTA protected</p>
			</div>
			<div className="book-with-confidence-booking-page__logo-container">
				<FooterAtolIcon height={40} width={40} />
				<span className="separator" />
				<IconABTACertification height={50} width={80} withColor={true} />
			</div>
		</div>
	);
};

export default memo(CondensedBookWithConfidence);
